<template>
  <div class="table-responsive">
    <table v-if="!loading" class="attendance table-bordered table-striped table-responsive">
        <thead>
          <tr>
            <td style="width: 30%;border-top:0px; border-left:0px;" :colspan="colspan">&nbsp;</td>
            <td :class="isHoliday(n)" v-for="n in dayInMonth" :key="uniqueId('date'+n)" style="width: 40px;">{{ n }}</td>
          </tr>
        </thead>

        <tbody style="overflow-x: auto;" v-if="listAttendance">
          <template v-for="(child, division) in listAttendance" >
            <tr :key="uniqueId('employee'+division)">
                <td class="grey" :colspan="dayInMonth+colspan"><b>{{division}}</b></td>
            </tr>
            <template v-for="(employee, position) in child">
              <tr :key="uniqueId('employee'+position)">
                  <td class="green" :colspan="dayInMonth+colspan"><b>{{position}}</b></td>
              </tr>
              
              <tr v-for="(data, nik) in employee" :key="uniqueId('employee'+nik)">
                  <td style="width: 12.6%"><b-link :href="'#/employee/all/detail/'+data.employee_id">{{data.name}}</b-link></td>
                  <td style="width: 10%" class="">{{data.employee_ho_name}}</td>
                  <td style="width: 5%" class="text-center">{{data.status_name}}</td>
                  <td>
                    <b-button size="sm" v-on:click="showHistory(data.employee_id)" variant="link" class="btn"  >
                      <i class="fa fa-history"></i>
                    </b-button>
                  </td>
                  <td v-for="n in dayInMonth" :class="isHoliday(n)" style="width:80px;" :key="uniqueId('date'+n)">
                    <span v-on:click="doAttendance(data.attd_status[n], data.notes[n], n, data.employee_id, data.path_file[n])" class="clicked">{{data.attd[n]}}</span>
                  </td>
              </tr>
            </template>
          </template>
        </tbody>

        <tbody style="overflow-x: auto;" v-else>
          <tr>
            <td :colspan="dayInMonth+2" class="text-center">No data</td>
          </tr>
        </tbody>
    </table>
    <!-- <table
      v-if="!loading"
      class="table-bordered table-striped table-responsive"
      style="width: 100%;"
    >
      <tr>
        <td style="width: 350px;">&nbsp;</td>
        <td
          class="text-center"
          v-for="n in dayInMonth"
          :key="uniqueId('date'+n)"
          style="width: 40px;"
        >{{ n }}</td>
      </tr>
      <tr v-for="(value, key) in listAttendance" :key="uniqueId('employee'+key)">
        <td>{{key}}</td>
        <td class="text-center" v-for="n in dayInMonth" :key="uniqueId('attendance'+n)" style="width: 40px;">
          <b-button @click="doAttendance(value[n], n, key)" variant="link" >{{value[n]}}</b-button>
        </td>
      </tr>
    </table> -->

    <div v-else>
      <loading></loading>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import loading from "@/templates/Loading.vue";
import * as moment from "moment";

export default {
  name: "attendance-list",
  components: { loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    },
    listAttendance: {
      type: [Array, Object],
      default: () => {}
    },
    dayInMonth: {
      type: Number,
      default: () => 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    month: {
      type: String,
      default: () => ''
    },
    year: {
      type: String,
      default: () => ''
    },
  },
  data() {
    return {
      colspan: 4
    };
  },
  methods: {
    reload() {
      this.$emit("reload");
    },
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {},
    doAttendance: function(event, notes, day, employee_id, path_file) {
      this.$emit("doAttendance", { value:event, notes:notes, day:day, employee_id:employee_id, path_file: path_file});
    },
    isHoliday: function(day) {
      let today = (parseInt(day) < 10) ? '0'+day:day;
      let date = this.year+'-'+this.month+'-'+today;
      let weekOfNumber = moment(date).format('E');
      return (weekOfNumber === '6' || weekOfNumber === '7') ? 'red text-center' : 'text-center';
    },
    showHistory: function(employee_id) {
      this.$emit("showHistory", this.month, this.year, employee_id);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
